import 'bootstrap';
import 'bootswatch/dist/slate/bootstrap.min.css';
import AuthorizeChecker from 'crowdaa-ux/components/AuthorizeChecker';
import HttpsRedirect from 'react-https-redirect';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import localeEN from 'react-intl/locale-data/en';
import localeFR from 'react-intl/locale-data/fr';
import queryString from 'query-string';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { addLocaleData, IntlProvider } from 'react-intl';
import UserContextProvider from 'crowdaa-ux/contexts/UserContextProvider';

import enUX from 'crowdaa-ux/translations/en';
import frUX from 'crowdaa-ux/translations/fr';
import VideoPlaylistPage from '../pages/VideoPlaylistPage';
import PlaylistPage from '../pages/PlaylistPage';
import en from '../translations/en';
import fr from '../translations/fr';

addLocaleData([...localeEN, ...localeFR]);

const language = navigator.language.split(/[-_]/)[0];
const messages = { en: { ...en, ...enUX }, fr: { ...fr, ...frUX } };

export default class App extends Component {
  constructor(props) {
    super(props);
    const parsed = queryString.parse(window.location.search);
    const state = {};
    ['auth_token', 'userId'].forEach((key) => {
      state[key] = parsed[key] || localStorage.getItem(key);
      if (parsed[key]) localStorage.setItem(key, parsed[key]);
    });
    this.state = state;
    this.handleErrorAuth = this.handleErrorAuth.bind(this);
  }

  getChildContext() {
    const { auth_token, userId } = this.state;
    return {
      apiURL: process.env.REACT_APP_API_URL,
      loginToken: auth_token,
      userId,
    };
  }

  handleErrorAuth() {
    this.setState({
      auth_token: null,
      userId: null,
    });
    localStorage.clear();
  }

  renderContent(location) {
    return (
      <HttpsRedirect>
        <div id="container">
          <div id="content-container">
            <AuthorizeChecker onError={this.handleErrorAuth} />
            <IntlProvider locale={language} messages={messages[language]}>
              <div>
                <Switch location={location}>
                  <UserContextProvider>
                    <Route
                      path="/"
                      render={() => {
                        const {
                          selectionId, url, trackId, autoplay,
                        } = queryString.parse(window.location.search);
                        const sId = selectionId
                          && (process.env.REACT_APP_ALLOWED_SELECTIONS.indexOf(selectionId) + 1)
                          ? selectionId : process.env.REACT_APP_DEFAULT_SELECTION;
                        const isMobile = window.innerWidth < 710;
                        if (isMobile) {
                          return <PlaylistPage
                            selectionId={sId}
                            url={url || window.location.href}
                            trackId={trackId}
                            autoplay={autoplay === 'true'}
                            isMobile={isMobile}
                          />;
                        }
                        return <VideoPlaylistPage
                          selectionId={sId}
                          url={url || window.location.href}
                          trackId={trackId}
                          autoplay={autoplay === 'true'}
                          isMobile={isMobile}
                        />;
                      }}
                    />
                  </UserContextProvider>

                </Switch>
              </div>
            </IntlProvider>
          </div>
        </div>
      </HttpsRedirect>
    );
  }

  render() {
    return (
      <BrowserRouter>
        <Route
          render={({ location }) => this.renderContent(location)
          }
        />
      </BrowserRouter>
    );
  }
}

App.childContextTypes = {
  apiURL: PropTypes.string,
  loginToken: PropTypes.string,
  userId: PropTypes.string,
};
